// All supported payment methods.
// value   — stored in DB (payments.payment_method, merchant.payment_methods)
// label   — display name shown in UI
// isDefault — included when merchant hasn't configured their list yet
export const ALL_PAYMENT_METHODS = [
	{ value: 'cash', label: 'Cash', isDefault: true },
	{ value: 'card_terminal', label: 'Card', isDefault: true },
	{ value: 'check', label: 'Check', isDefault: true },
	{ value: 'apple_pay', label: 'Apple Pay', isDefault: false },
	{ value: 'google_pay', label: 'Google Pay', isDefault: false },
	{ value: 'paypal', label: 'PayPal', isDefault: false },
	{ value: 'venmo', label: 'Venmo', isDefault: false },
	{ value: 'cash_app', label: 'Cash App', isDefault: false },
	{ value: 'e_transfer', label: 'e-Transfer', isDefault: false },
	{ value: 'gift_card', label: 'Gift Card', isDefault: false },
	{ value: 'square_terminal', label: 'Square Terminal', isDefault: false },
	{ value: 'square_card', label: 'Square Card', isDefault: false },
]

// Values of the default payment methods (used when merchant.payment_methods is null)
export const DEFAULT_PAYMENT_METHOD_VALUES = ALL_PAYMENT_METHODS
	.filter(m => m.isDefault)
	.map(m => m.value)

/**
 * Returns the active payment method objects for a merchant.
 * If merchant.payment_methods is null/empty, returns the default set.
 * @param {string[] | null | undefined} merchantPaymentMethods
 * @returns {{ value: string, label: string, isDefault: boolean }[]}
 */
export function getActiveMethods(merchantPaymentMethods) {
	const active = merchantPaymentMethods && merchantPaymentMethods.length > 0
		? merchantPaymentMethods
		: DEFAULT_PAYMENT_METHOD_VALUES

	// Preserve the canonical order from ALL_PAYMENT_METHODS
	return ALL_PAYMENT_METHODS.filter(m => active.includes(m.value))
}

/**
 * Returns the display label for a payment method value.
 * Falls back to the raw value if not found.
 * @param {string} value
 * @returns {string}
 */
export function getPaymentMethodLabel(value) {
	return ALL_PAYMENT_METHODS.find(m => m.value === value)?.label ?? value
}
